import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectPreviousQueryId = createBasicSelector(
  selectBase,
  base => base.previousQueryId
)
